const socketWpp = io.connect(`${location.protocol}//${location.hostname}:4000`);

module.exports = {
	socketWpp
}
